import { GridColDef } from '@mui/x-data-grid-premium';

export const actionColumnConfig: Partial<GridColDef> = {
  disableColumnMenu: true,
  disableExport: true,
  disableReorder: true,
  filterable: false,
  headerName: '',
  hideable: false,
  pinnable: true,
  sortable: false,
};
